import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { RoutesPaths } from "./constant";

function PublicRoute({ children }) {
  const isLogin = localStorage.getItem("authToken") || null;

  if (isLogin) {
    return <Navigate to={RoutesPaths.DASHBOARD} />;
  }
  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicRoute;
